<template>
  <Loader v-if="loader" />

  <Dialog v-model:visible="visibleUpdate" modal header="Nuovo Aggiornamento" :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" @hide="updateTutorial">
    <div class="m-3">
      <Fieldset v-for="content in content_update" :key="content.title" :legend="content.title" class="m-2">
        <p v-if="content.content.length">
          <ul>
            <li v-for="item in content.content" :key="item">
              {{ item }}
            </li>
          </ul>
        </p>
      </Fieldset>
    </div>
      
    <div class="m-3">
      <Checkbox v-model="is_inactive_tutorial" id="is_inactive_tutorial" :binary="true"/>
      <label for="is_inactive_tutorial"> Non visualizzare più </label>
    </div>
  </Dialog>

  <div class="welcome-container">
    <h2>Benvenuto</h2>
    <div class="user-info">
      <small>Hai effettuato l'accesso come: <br/><span class="email">{{currentUser.email}}</span></small>
    </div>
      
    <div class="stats-cards">
      <div class="stat-card card-primary" @click="goToPath('newContract')">
        <div class="stat-card-content">
          <div class="stat-title">Nuovo Contratto</div>
          <div class="stat-icon">
            <i class="pi pi-file-edit"></i>
          </div>
        </div>
      </div>
      
      <div class="stat-card card-secondary" @click="goToPath('uploaded')">
        <div class="stat-card-content">
          <div class="stat-title">Storico Caricamenti</div>
          <div class="stat-icon">
            <i class="pi pi-history"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, ref } from 'vue';
import { useStore } from 'vuex'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import Loader from '@/components/Loader.vue'
import roles from '@/config/roles'
import { useRouter } from 'vue-router'

export default {
  components: {
    Loader,
  },

  setup () {
    const router = useRouter()
    const loader = ref(false);
    const store = useStore()
    const currentUser = ref(store.state.auth.user)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const chartRefBanks = ref(null);
    const ctrs = ref({
      labels: [],
      datasets: [
          {
              label: 'Contratti Validi',
              backgroundColor: '#34d5eb',
              data: []
          },
          {
              label: 'Contratti Errati',
              backgroundColor: '#eb4f34',
              data: []
          },
          {
              label: 'Contratti Da Validare',
              backgroundColor: '#b3b3b3',
              data: []
          },    
      ]
    });
    const visibleUpdate = ref(false);
    const is_inactive_tutorial = ref();
    const content_update = ref();

    onMounted(() => { 
      if (currentUser.value.role == 'agent') {
        Promise.all([getUpdate()])
        .then(()=>{
          if (content_update.value.length) {
            Promise.all([getIsActiveTutorial()])
          }
        })
      }
    });
    

    const getUpdate = () => {
      return service.getUpdate()
      .then((res) => {
        content_update.value = res.items
      })
    }
    
    const getIsActiveTutorial = async () => {
      await service.getIsActiveTutorial(currentUser.value.id)
      .then((res) => {
        visibleUpdate.value = res.items.is_visible_tutorial
        is_inactive_tutorial.value = !visibleUpdate.value
      })
    }
    
    const updateTutorial = () => {
      if(is_inactive_tutorial.value){
        setInactiveTutorial()
      }
    }

    const setInactiveTutorial = async () => {
      await service.setInactiveTutorial(currentUser.value.id)
    }

    const goToPath = (id) => {
      switch (id) {
        case 'newContract':
          router.push({path: '/multisito'})
          break;
      
        case 'uploaded':
          router.push({path: '/caricamenti-multisito'})
          break;
      }
    }

    return {
      loader,
      currentUser,
      roles,
      goToPath,
      visibleUpdate,
      updateTutorial,
      is_inactive_tutorial,
      content_update,
    }
  }
}
</script>

<style scoped>
/* Importazione del font Montserrat */
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

/* Container principale */
.welcome-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 3rem 2rem;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
}

/* Titolo */
h2 {
  color: #215159;
  font-weight: 600;
  font-size: 2.8rem;
  margin-bottom: 1.5rem;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
}

/* Info utente */
.user-info {
  margin-bottom: 3rem;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
}

small {
  color: #64748b;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
}

.email {
  font-size: 14px;
  color: #05b5a6;
  font-weight: 600;
  background: rgba(5, 181, 166, 0.1);
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  display: inline-block;
  margin-top: 0.3rem;
  font-family: 'Montserrat', sans-serif;
}

.stats-cards {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 3rem;
  margin: 4rem auto;
  max-width: 1200px;
}

.stat-card {
  flex: 0 0 45%;
  min-width: 560px;
  max-width: 500px;
  height: 250px;
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
}

.card-primary {
  background: linear-gradient(135deg, #215159 0%, #1a7f89 100%);
}

.card-secondary {
  background: linear-gradient(135deg, #05b5a6 0%, #04867b 100%);
}

.stat-card:hover {
  transform: translateY(-7px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 150px;
  height: 150px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transform: translate(40px, -40px);
}

.stat-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  transform: translate(-30px, 30px);
}

.stat-card-content {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stat-title {
  color: white;
  font-size: 1.8rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: 'Montserrat', sans-serif;
}

.stat-icon {
  width: 60px;
  height: 60px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  position: relative;
}

.stat-icon i {
  font-size: 1.8rem;
  color: white;
}

/* Effetto di ondulazione */
@keyframes ripple {
  0% {
    transform: scale(0.8);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.stat-card:hover .stat-icon:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  animation: ripple 1.5s infinite;
}

/* Stilizzazione del dialog */
:deep(.p-dialog .p-dialog-header) {
  background-color: #215159;
  color: white;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

:deep(.p-dialog .p-dialog-content) {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

:deep(.p-fieldset) {
  border-radius: 8px;
  border: 1px solid rgba(33, 81, 89, 0.2);
}

:deep(.p-fieldset-legend) {
  background-color: #05b5a6;
  color: white;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-weight: 600;
}

/* Lista con punti */
li {
  list-style-type: disc;
  margin-bottom: 0.5rem;
}

/* Responsività */
@media (max-width: 992px) {
  .stat-card {
    min-width: 320px;
    flex: 0 0 100%;
    max-width: 500px;
  }
  
  .stats-cards {
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .stat-card {
    min-width: 280px;
    height: 160px;
    padding: 2rem;
  }

  .stat-title {
    font-size: 1.6rem;
  }
  
  h2 {
    font-size: 2.2rem;
  }
}

@media (max-width: 576px) {
  .welcome-container {
    padding: 1.5rem;
  }

  .stats-cards {
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;
  }

  .stat-card {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    height: 140px;
  }

  .stat-title {
    font-size: 1.4rem;
  }

  .stat-icon {
    width: 50px;
    height: 50px;
  }

  .stat-icon i {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 2rem;
  }
}
</style>